"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateOptions = exports.getOptions = exports.createTranslatedOptionsFromMap = exports.createOptionsFromMap = exports.createOption = exports.addEmptyOption = void 0;
var createOption = exports.createOption = function createOption(label, value) {
  return {
    label: label,
    value: value
  };
};
var createOptionsFromMap = exports.createOptionsFromMap = function createOptionsFromMap(valueLabelMap) {
  return Object.keys(valueLabelMap).map(function (value) {
    return createOption(valueLabelMap[value], value);
  });
};
var translateOptions = exports.translateOptions = function translateOptions(options, formatMessage) {
  return options.map(function (option) {
    return createOption(formatMessage({
      id: option.label
    }), option.value);
  });
};
var createTranslatedOptionsFromMap = exports.createTranslatedOptionsFromMap = function createTranslatedOptionsFromMap(valueLabelMap, formatMessage) {
  return translateOptions(createOptionsFromMap(valueLabelMap), formatMessage);
};
var addEmptyOption = exports.addEmptyOption = function addEmptyOption(options) {
  var isEmptyRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return isEmptyRequired ? [createOption('', null)].concat(options) : options;
};
var getOptions = exports.getOptions = function getOptions(object) {
  var formatMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var isEmptyRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return addEmptyOption(formatMessage ? createTranslatedOptionsFromMap(object, formatMessage) : createOptionsFromMap(object), isEmptyRequired);
};